import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ role, roles, children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-400 font-mono-num">
        Initializing…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  const allowed = roles || (role ? [role] : null);
  if (allowed && !allowed.includes(user.role)) {
    const isAdminRole = user.role === "admin" || user.role === "secondary_admin";
    return <Navigate to={isAdminRole ? "/admin" : "/operator"} replace />;
  }
  return children;
}
